import $ from "jquery";

import { useHeader } from "./nsLayout/chunks/nsHeader";
import { useHeaderNavigation } from "./nsLayout/chunks/nsHeaderNavigation";
import { useMobileHeader } from "./nsLayout/chunks/nsMobileHeader";
import { useMobileExpansion } from "./nsLayout/chunks/nsMobileExpansion";
import { useFooter } from "./nsLayout/chunks/nsFooter";
import { useSearchDropdown } from "./nsLayout/chunks/nsSearchDropdown";

import { useTopBanner } from "./nsLayout/elements/nsTopBanner";
import { useCardsGrid } from "./nsLayout/elements/nsCardsGrid";
import { useModal } from "./nsLayout/elements/nsModal";
import { useGlossary } from "./nsLayout/elements/nsGlossary";

import { useConstructorPage } from "./pages/nsConstructorPage";

const { initHeader } = useHeader();
const { initHeaderNavigation } = useHeaderNavigation();
const { initMobileHeader } = useMobileHeader();
const { initMobileExpansions } = useMobileExpansion();
const { initFooter } = useFooter();
const { initContentPadding } = useConstructorPage();
const { initTopBanner } = useTopBanner();
const { initCardsGrid } = useCardsGrid();
const { initModals } = useModal();
const { initSearchDropdown } = useSearchDropdown();
const { initGlossary } = useGlossary();

window.$ = $;
window.jQuery = $;
require("./elements/common");

// Plugins
require("owl.carousel/dist/owl.carousel.min");
//плагин для реакции на достижение позиции элемента при скруллинге
require("jquery-viewport-checker/src/jquery.viewportchecker.js");
//vimeo on nsVideoPalyer.js

// Chunks
require("./nsLayout/chunks/nsCustomerStories");
require("./nsLayout/chunks/formApplyNow");
require("./nsLayout/chunks/nsForm");
require("./nsLayout/chunks/nsShopFilter");
require("./nsLayout/chunks/nsApmFinderFilter.js");
require("./nsLayout/chunks/nsPopUp.js");
require("./nsLayout/chunks/nsMicroEnterpriseMerchantsForm.js");
initHeader();
initHeaderNavigation();
initMobileHeader();
initMobileExpansions();
initFooter();
initSearchDropdown();

// Elements
require("./nsLayout/elements/nsButton");
require("./nsLayout/elements/nsUsingSolutions");
require("./nsLayout/elements/nsLogoCarousel");
require("./nsLayout/elements/nsCardsCarousel");
require("./nsLayout/elements/nsMultiselect");
require("./nsLayout/elements/nsMultiselectBig");
require("./nsLayout/elements/nsParallaxElement");
require("./nsLayout/elements/nsSingleselect");
require("./nsLayout/elements/nsCardsLine");
require("./nsLayout/elements/nsBlogRegularTextWithSlider");
require("./nsLayout/elements/nsImageGreenAside");
require("./nsLayout/elements/nsIntroductionsWithSmallCards");
require("./nsLayout/elements/nsChangeBackgroundOnScroll");
require("./nsLayout/elements/nsVideoPalyer");
require("./nsLayout/elements/nsRotateElementByHover");
require("./nsLayout/elements/nsDropdownSlider");
require("./nsLayout/elements/nsThankYouWhitePaper");
require("./nsLayout/elements/redirectToDemoPaymentPage");
require("./nsLayout/elements/nsDemoPaymentPage");
require("./nsLayout/elements/nsTextAndImageReverseSlider");
require("./nsLayout/elements/nsStickySlider.js");
require("./nsLayout/elements/nsCustomerStoriesHeader.js");
require("./nsLayout/elements/nsTableOfContentsBlog.js");
require("./nsLayout/elements/nsQuotesCarousel");
require("./nsLayout/elements/nsMerchantEnterpriseCalc");
require("./nsLayout/elements/nsFormChunkPopup");

initCardsGrid();
initModals();
initTopBanner();
initGlossary();

// Content
initContentPadding();
